import { createSelector } from 'reselect';

const storeFeedbacks = (store, props) => store.feedback.feedbacks;

export const getFeedbacks = createSelector(storeFeedbacks, feedbacks =>
  Object.keys(feedbacks).map(key => feedbacks[key])
);



// WEBPACK FOOTER //
// ./src/selectors/feedback.js